import { checkIsPlatform, tokens } from '@airtel/air-design-system';
import { Dimensions, StyleSheet } from 'react-native';
export var getStatusCardWidgetStyles = (props, isLargeScreen) => {
  var _props$headerHeight = props.headerHeight,
    headerHeight = _props$headerHeight === void 0 ? 74 : _props$headerHeight;
  var spacing = tokens.spacing;
  var subTitleStyles = {
    marginTop: isLargeScreen ? spacing.SPACING_8 : spacing.SPACING_4
  };
  return StyleSheet.create({
    cardPadding: {
      paddingHorizontal: tokens.spacing.SPACING_0,
      paddingVertical: tokens.spacing.SPACING_20
    },
    showAsFullPage: {
      minHeight: Dimensions.get('window').height - headerHeight,
      flex: 1,
      justifyContent: 'center'
    },
    absolute: {
      position: checkIsPlatform('web') ? 'fixed' : 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 99
    },
    contentContainer: {
      paddingHorizontal: tokens.spacing.SPACING_20,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    buttonContainer: {
      width: '100%',
      marginTop: spacing.SPACING_20
    },
    subTitle: Object.assign(Object.assign({}, subTitleStyles), {
      alignSelf: 'center'
    }),
    hint: {
      marginTop: spacing.SPACING_16
    },
    imageContainer: {
      alignSelf: 'center'
    },
    textCenter: {
      textAlign: 'center'
    },
    offerStrip: {
      marginTop: spacing.SPACING_20,
      alignSelf: 'center'
    },
    callout: {
      marginTop: spacing.SPACING_20
    }
  });
};